<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction">
    </popup>
    <form>
      <div class="inner">
        <add-button v-if="$_createActionAllowed" :title="'Přidat odběratele' | translate" route-name="subscriberNew"></add-button>
        <h1 v-translate>Odběratelé</h1>
      </div>

      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
            </div>
          <div class="field_right">
            <select-box
                id="active"
                v-model="formFields.active"
                :options="subscriberActiveOptions"
            >
              <translate class="translate">Stav odběratele</translate>
            </select-box>
          </div>
          <div class="field_left" v-if="showOperatorFilter">
            <select-box
                id="business_model"
                :options="businessModelOptions"
                v-model="formFields.idBusinessModel"
                ref="businessmodelref"
            >
              <translate class="translate">Business model</translate>
            </select-box>
          </div>
          <div :class="{'field_left': !showOperatorFilter, 'field_right': showOperatorFilter}">
            <select-box
                id="device_type"
                :options="deviceTypesOptions"
                v-model="formFields.idDeviceType"
                ref="devicetyperef"
            >
              <translate class="translate">Typ zařízení</translate>
            </select-box>
          </div>
          <div class="advanced_filter">
            <p class="expand" :class="{'open': advancedFilterOpen, 'filtered': isAdvancedFilterChanged}">
              <a @click="toggleAdvancedFilter"><translate class="translate">Rozšířený filtr</translate></a>
            </p>
            <div class="advanced_filter_content" :class="{'open': advancedFilterOpen}">
            <div class="field_left" v-if="$_loggedUser_action_allowed('packages')">
              <select-box
                  id="channel_package"
                  :options="channelPackagesOptions"
                  v-model="formFields.idChannelPackage"
                  ref="channelpackageref"
              >
                  <translate class="translate">Balíček</translate>
              </select-box>
            </div>
              <div class="field_right" v-if="showOperatorFilter">
                <select-box
                    id="operatorselect"
                    :options="operatorOptions"
                    v-model="formFields.operator"
                    ref="operatorselectref"
                >
                  <translate class="translate">Operátor</translate>
                </select-box>
              </div>
              <div :class="{'field_left': showOperatorFilter, 'field_right': !showOperatorFilter}" v-if="$_loggedUser_action_allowed('services')">
                <select-box
                    id="services_type"
                    :options="servicesOptions"
                    v-model="formFields.idService"
                    ref="serviceref"
                >
                  <translate class="translate">Služba</translate>
                </select-box>
              </div>
          <div class="field_right" v-if="$_loggedUser_canChangeOperator && !$store.getters.getSelectedOperatorId">
            <select-box
                id="operator_type"
                :options="operatorTypeOptions"
                v-model="formFields.operatorType"
                ref="operatortyperef"
            >
              <translate class="translate">Typ operátora</translate>
            </select-box>
          </div>
          <div class="field_left">
            <date-picker
                id="active_from"
                attrKey="activeFrom"
                date-format="d. m. yy"
                v-model="formFields.activeFrom"
                @update-date="updateFormDate"
            >
              <translate class="translate">Platnost od</translate>
            </date-picker>
          </div>
          <div class="field_right">
            <date-picker
                id="active_to"
                attrKey="activeTo"
                date-format="d. m. yy"
                v-model="formFields.activeTo"
                @update-date="updateFormDate"
            >
              <translate class="translate">Platnost do</translate>
            </date-picker>
          </div>
            <multiselect-searchbox
                v-if="$_loggedUser_action_allowed('operatorTags')  && !$store.getters.getSelectedOperatorId"
                :searchFunction="searchOperatorTags"
                v-model="formFields.operatorTagsIds"
            >
              <translate class="translate">Štítky operátora</translate>
            </multiselect-searchbox>
              <multiselect-searchbox
                  v-if="$_loggedUser_action_allowed('tags')"
                  :searchFunction="searchTags"
                  v-model="formFields.tagsIds"
              >
                <translate class="translate">Štítky odběratele</translate>
              </multiselect-searchbox>
          <div class="field_left field_full">
            <p class="field checkbox_label" v-translate>Typ odběratele</p>
            <div class="field checkboxes">
              <filter-checkbox
                  v-for="type in subscriberTypes"
                  :key="type.id"
                  :id="subscriberTypeFilterId(type.id)"
                  :name="type.text"
                  :val="type.id"
                  v-model="formFields.subscriberType">{{ type.text }}
              </filter-checkbox>
              <filter-checkbox
                  key="testerSubscriber"
                  id="testerSubscriber"
                  name="testerSubscriber"
                  :val="true"
                  v-model="formFields.tester">Testovací
              </filter-checkbox>
            </div>
          </div>
          </div>
            </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="table_overflow">
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
              <thead>
              <tr>
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in sortingTableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              </thead>
              <subscriber-row
                  v-for="entity in entities"
                  :entity="entity"
                  :key="entity.id"
                  :selectedSubscribers="selectedEntities"
                  @input="select"
                  @updateSubscriber="updateEntity"
                  @deleteSubscriber="deleteEntity"
              ></subscriber-row>
            </table>
          </div>

          <list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              @select-all="toggleSelectAll"
              @run-multiple-action="executeMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import SubscriberRow from "@/components/views/subscribers/SubscriberRow"
import subscribers from "@/components/views/subscribers/mixins/subscribers"
import listActions from "@/components/mixins/list-actions"
import tabs from "@/components/mixins/tabs"
import {prependOptions} from "@/utils/helpers";

export default {
  name: "SubscriberList",
  components: {SubscriberRow},
  mixins: [subscribers, listActions, tabs],
  data() {
    return {
      moduleName: 'subscribers',
      dateFields: ['activeFrom', 'activeTo'],
      skipFormfieldWatcher: true,
      formFields: {
        active: 'all',
        activeFrom: '',
        activeTo: '',
        subscriberType: [],
        tester: false,
        idDeviceType: 0,
        idService: 0,
        idChannelPackage: 0,
        idBusinessModel: null,
        operatorType: null,
        operatorTagsIds: [],
        tagsIds: [],
        operator: 0,
      },
      selectedSubscribers: [],
      device_types: [],
      channel_packages: [],
      business_models: [],
      operators: [],
      services: [],
      subscribers: [],
      advancedFilterOpen: false,
      skipEvent: false,
      callNumber: 0,
      skipWatcher: false,
    }
  },
  created(SubscriberService,
          DeviceTypeService,
          ServiceService,
          PackageService,
          BusinessModelService,
          OperatorTagService,
          TagService,
          OperatorService
  ) {
    this.entityService = SubscriberService
    this.deviceTypeService = DeviceTypeService
    this.serviceService = ServiceService
    this.packageService = PackageService
    this.businessModelService = BusinessModelService
    this.operatorTagService = OperatorTagService;
    this.tagService = TagService;
    this.operatorService = OperatorService;
    const formOperator = this.getDefaultValue("operator") ? this.getDefaultValue("operator"): (this.$_loggedUser_selectedOperatorId ? this.$_loggedUser_selectedOperatorId : 0);
    const formBusinessModel = this.getDefaultValue('idBusinessModel') ?this.getDefaultValue('idBusinessModel'): 0;

    Promise.all([
      this.deviceTypeService.getEntitiesForSelectBox(),
      this.$_loggedUser_action_allowed('services', 'read') ? this.serviceService.getEntitiesForSelectBox(formOperator, {id_business_model: formBusinessModel}) : null,
      this.$_loggedUser_action_allowed('packages', 'read') ? this.packageService.getEntitiesForSelectBox(formOperator, {id_business_model: formBusinessModel}) : null,
      this.getSubscriberTypeList(),
      this.$_loggedUser_action_allowed('businessModels', 'read') ? this.businessModelService.getEntitiesForSelectBox() : null,
      this.showOperatorFilter ? this.operatorService.getOperators({id_business_model: formBusinessModel}) : null
    ]).then((responses) => {
      this.device_types = responses[0] ? responses[0]['device_types'] : null;
      this.services = responses[1] ? responses[1]['services'] : null;
      this.channel_packages = responses[2] ? responses[2]['channel_packages'] : null;
      this.business_models = responses[4] ? responses[4]['business_models']: null;
      this.operators = responses[5] ? responses[5]['operators']: null;
      this.skipEvent = true;
      this.loadDefaultByKey('operator');
      this.createdInit()
      if(this.formFields.idBusinessModel ||this.formFields.operator){
        this.onBusinessModelChange()
      }
    }).catch((error) => {
      this.setErrorMessage(error['error_message']);
    });
  },
  computed: {
    isAdvancedFilterChanged(){
      return this.formFields.idChannelPackage != 0
          || this.formFields.operator != 0
          || this.formFields.idService != 0
          || this.formFields.operatorType != null
          || (this.formFields.activeFrom != '' && this.formFields.activeFrom != null)
          || (this.formFields.activeTo != '' && this.formFields.activeTo != null)
          || this.formFields.operatorTagsIds.length != 0
          || this.formFields.tagsIds.length != 0
          || this.formFields.subscriberType.length != 0
          || this.formFields.tester
    },
    multipleActionOptions() {
      let options = [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ];
      if(this.$_updateActionAllowed){
        options.push({value: 'activate', text: this.$gettext('Aktivovat')});
        options.push({value: 'deactivate', text: this.$gettext('Deaktivovat')});
        options.push({value: 'remove-cache', text: this.$gettext('Smazat cache všech zařízení')});
      }
      if(this.$_deleteActionAllowed){
        options.push( {value: 'delete', text: this.$gettext('Smazat')});
      }

      return options;
    },
    sortingTableTitles() {
      let titles = [
        {id: 1, name: this.$gettext('Příjmení jméno'), column: 'sSurname'},
        {id: 2, name: this.$gettext('Název firmy'), column: 'sCompany'},
      ]

      if (this.$_readActionAllowedAll) {
        titles.push({id: 3, name: this.$gettext('Operátor'), column: 'sOperatorName'})
      }

      titles = titles.concat([
        {id: 4, name: this.$gettext('Typ subjektu'), column: 'sSubjectType'},
        {id: 5, name: this.$gettext('Typ odběratele'), column: 'sSubscriberType'},
        {id: 6, name: this.$gettext('Město'), column: 'sTown'},
        {id: 7, name: this.$gettext('Aktivní zařízení'), column: 'sActiveDevicesCount'},
        {id: 8, name: this.$gettext('Poslední start zařízení'), column: 'sLastDeviceStartLog'},
        {id: 9, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
        {id: 10, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ])

      return titles
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      headers.surname.callback = (entity) => {return entity.surname + ' ' + entity.firstname; };
      headers.company.callback = (entity) => {return entity.company_name; };
      headers.subject_type.callback = (entity) => {return entity.subject_type === 'person' ? this.$gettext('Fyzická osoba') : this.$gettext('Právnická osoba')};
      headers.subscriber_type.callback = (entity) => {return entity.subscriber_type_name};
      headers.town.callback = (entity) => {return entity.address.town? entity.address.town: ''};
      headers.last_device_start_log.callback = (entity) => {return entity.last_device_start_log ? this.$_datetime_format(entity.last_device_start_log) : ''};

      return headers;
    },
    deviceTypesOptions() {
      if (this.device_types) {
          return prependOptions(this._.map(this.device_types, function (item) {
              return {id: item['id'], text: item['name']}
          }), this.$gettext('Všechny'))
      } else {
          return []
      }
    },
    servicesOptions() {
      if (this.services) {
          return prependOptions(this._.map(this.services, function (item) {
              return {id: item['id'], text: item['name']}
          }), this.$gettext('Všechny'))
      } else {
          return []
      }
    },
    channelPackagesOptions() {
      if (this.channel_packages) {
          return prependOptions(this._.map(this.channel_packages, function (item) {
              return {id: item['id'], text: item['name']}
          }), this.$gettext('Všechny'))
      } else {
          return []
      }
    },
    businessModelOptions(){
      let ret = this.business_models ? this.business_models: [];
      return [{id: null, text: this.$gettext('Všechny')}].concat(ret);
    },
    operatorOptions() {
      if (this.operators) {
        let data = this._.map(this.operators, function (item) {
          return {id: item['id'], text: item['name']}
        });
        data.unshift({'id': 0, 'text':this.$gettext('Všechny')});
        return [...data];
      } else {
        return []
      }
    },
    showOperatorFilter(){
      return this.$_loggedUser_action_allowed('operators') && this.$_loggedUser_canChangeOperator && !this.$_loggedUser_isChangedOperator;
    },
    filterIdOperator(){
      if(this.showOperatorFilter){
        return this.formFields.operator
      }else{
        return this.$_loggedUser_selectedOperatorId;
      }
    }
  },
  methods: {
    getDefaultValue(key){
      let data = {module: this.moduleName, key: key}
      if (this.$store.getters.hasSetting(data)){
        return this.$store.getters.getSetting(data)
      }else{
        return null;
      }
    },
    executeMultipleAction(action, activeKey = 'active') {
      if(action === 'remove-cache'){
        this.deleteCache();
      }else {
        this.runMultipleAction(action, activeKey);
      }
    },
    deleteCache(){
      this.entityService.deleteSubscribersDevicesCache({'subscriber_ids': this.filteredSelectedEntities.join()});
      this.setSuccessMessage();
    },
    subscriberTypeFilterId(id) {
      return 'subscriber-type-' + id
    },
    loadTags(){
      return !!(this.$_loggedUser_action_allowed('tags') && this.loadDefaultByKey('tagsIds'));
    },
    loadServices(){
      return !!(this.$_loggedUser_action_allowed('services') && this.loadDefaultByKey('idService'));
    },
    loadPackages(){
      return !!(this.$_loggedUser_action_allowed('packages') && this.loadDefaultByKey('idChannelPackage'));
    },
    loadOperator(){
      return !!(this.loadDefaultByKey('operator') && this.formFields.operator !== 0);
    },
    loadBusinessModel(){
      return !!(this.$_loggedUser_action_allowed('businessModels')
          && this.loadDefaultByKey('idBusinessModel')
          && !this.$store.getters.getSelectedOperatorId);

    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('active')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('activeFrom')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('activeTo')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('subscriberType')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('idDeviceType')) {
        anyChanges = true
      }
      if(this.loadServices()){
        anyChanges = true;
      }
      if(this.loadPackages()){
        anyChanges = true;
      }
      if(this.loadDefaultByKey('advancedFilterOpen')) {
        this.advancedFilterOpen = this.formFields.advancedFilterOpen;
        delete this.formFields.advancedFilterOpen;
      }
      if(this.loadBusinessModel()){
        anyChanges = true;
      }
      if(this.loadTags()){
        anyChanges = true;
      }
      if (this.$_loggedUser_action_allowed('operators')
          && this.loadDefaultByKey('operatorType')
          && !this.$store.getters.getSelectedOperatorId) {
        anyChanges = true
      }
      if (this.$_loggedUser_action_allowed('operatorTags')
          && this.loadDefaultByKey('operatorTagsIds')
          && !this.$store.getters.getSelectedOperatorId) {
        anyChanges = true;
      }
      if(this.loadOperator()){
        anyChanges = true;
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('active', this.formFields.active)
      this.setUserSetting('activeFrom', this.formFields.activeFrom)
      this.setUserSetting('activeTo', this.formFields.activeTo)
      this.setUserSetting('subscriberType', this.formFields.subscriberType)
      this.setUserSetting('idDeviceType', this.formFields.idDeviceType)
      this.setUserSetting('idService', this.formFields.idService)
      this.setUserSetting('idChannelPackage', this.formFields.idChannelPackage)
      this.setUserSetting('idBusinessModel', this.formFields.idBusinessModel)
      this.setUserSetting('operatorType', this.formFields.operatorType)
      this.setUserSetting('operatorTagsIds', this.formFields.operatorTagsIds)
      this.setUserSetting('tagsIds', this.formFields.tagsIds)
      this.setUserSetting('advancedFilterOpen', this.advancedFilterOpen)
      this.setUserSetting('operator', this.formFields.operator)
    },
    updateFormDate(dateInfo) {
      this.formFields[dateInfo.attrKey] = dateInfo.date
    },
    searchTags(search, selectAll=false, idBusinessModel){
      const businessModel = idBusinessModel !== null ? idBusinessModel : this.formFields.idBusinessModel;
      return this.tagService.searchTagByNameAndOperatorId(
          this.filterIdOperator,
          {name_search: search, select_all: selectAll, id_business_model: businessModel}
      );
    },
    searchOperatorTags(search, selectAll=false){
      return this.operatorTagService.searchTagsByName({name_search: search, select_all: selectAll})
    },
    _processListErrorMessage(error) {
      let errorMessage = error['error_message']
      if (this._.includes(errorMessage, 'active devices')) {
        errorMessage = this.getCannotDeleteHasDevicesMessage()
      }
      if (this._.includes(errorMessage, "Active to value must be greater than active to value.")) {
        errorMessage = this.$gettext('Nevalidní hodnoty filtrů "Platnost od" a "Platnost do".')
      }
      return errorMessage
    },
    _beforeOwnerOperatorChange(){
      this.formFields.idBusinessModel = null;
      this.formFields.operatorType = null;
      this.formFields.operatorTagsIds = [];
      this.formFields.tagsIds = [];
    },
    toggleAdvancedFilter(){
      this.advancedFilterOpen = !this.advancedFilterOpen;
      this.saveFilterValues();
    },
    onBusinessModelChange(){
      Promise.all([
        this.$_loggedUser_action_allowed('services', 'read') ? this.serviceService.getEntitiesForSelectBox(this.filterIdOperator, {id_business_model: this.formFields.idBusinessModel}) : null,
        this.$_loggedUser_action_allowed('packages', 'read') ? this.packageService.getEntitiesForSelectBox(this.filterIdOperator, {id_business_model: this.formFields.idBusinessModel}) : null,
        this.showOperatorFilter ? this.operatorService.getOperators({id_business_model: this.formFields.idBusinessModel}) : null
      ]).then((responses) => {
        this.services = responses[0] ? responses[0]['services'] : null;
        this.channel_packages = responses[1] ? responses[1]['channel_packages'] : null;
        this.operators = responses[2] ? responses[2]['operators']: null;
        this.createdInit()
      }).catch((error) => {
        this.setErrorMessage(error['error_message']);
      });
    },
    onOperatorChange(){
      Promise.all([
        this.$_loggedUser_action_allowed('services', 'read') ? this.serviceService.getEntitiesForSelectBox(this.filterIdOperator, {id_business_model: this.formFields.idBusinessModel}) : null,
        this.$_loggedUser_action_allowed('packages', 'read') ? this.packageService.getEntitiesForSelectBox(this.filterIdOperator, {id_business_model: this.formFields.idBusinessModel}) : null,
      ]).then((responses) => {
        this.services = responses[0] ? responses[0]['services'] : null;
        this.channel_packages = responses[1] ? responses[1]['channel_packages'] : null;
        this.createdInit()
      }).catch((error) => {
        this.setErrorMessage(error['error_message']);
      });
    },
  },
  watch: {
    "formFields.idBusinessModel"(){

      this.callNumber++;
      this.skipEvent = true;
      this.formFields.operator = 0;
      this.formFields.idChannelPackage = 0;
      this.formFields.idService = 0;
      this.formFields.tagsIds = [];
      this.onBusinessModelChange();
    },
    "formFields.operator"(){
      if(this.skipEvent){
        this.skipEvent = false;
        return;
      }
      this.formFields.idChannelPackage = 0;
      this.formFields.idService = 0;
      this.formFields.tagsIds = [];
      this.onOperatorChange();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/SubscriberList.vue